export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9980.381f5724.jpg";